export const DEFAULT_TIMEOUT = 60000;
export const INTERNAL_ERROR_MARKERS = ['RHUMB_GLOBAL_ERROR', 'RHUMB_GLOBAL_ERROR_BOUNDARY'];
const unexpectedRouteError = new Error('Unexpected route visited. Please see https://product.hubteam.com/docs/frontend/docs/react-rhumb.html#unexpected-route-tracking for more info.');
Object.defineProperty(unexpectedRouteError, 'stack', {
  value: undefined,
  writable: true,
  configurable: true
});
export const UNEXPECTED_ROUTE_ERROR = unexpectedRouteError;